@if ({ open: isQueryBuilderVisible$ | ngrxPush }; as builder) {
    @if (!builder.open) {
        <clmi-simple-view
            [config]="config"
            (formFiltersEvent)="formFiltersEvent.emit($event)"
        ></clmi-simple-view>
    }
    @if (builder.open) {
        <clmi-query-builder
            [showSaveButton]="showSaveButton"
            [config]="config"
            (formFiltersEvent)="formFiltersEvent.emit($event)"
        ></clmi-query-builder>
    }
}
